import { render, staticRenderFns } from "./ReminderStep.vue?vue&type=template&id=9eeda172&scoped=true&"
import script from "./ReminderStep.vue?vue&type=script&lang=js&"
export * from "./ReminderStep.vue?vue&type=script&lang=js&"
import style0 from "./ReminderStep.vue?vue&type=style&index=0&id=9eeda172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eeda172",
  null
  
)

export default component.exports